import React, { useEffect, useState } from "react";
import { AiOutlineDelete } from "react-icons/ai";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import LoaderGlobal from "../../../../Components/Loader/LoaderGlobal";
import RenderLibrarySkeleton from "../../../../Components/SkeletonLoader/RenderLibrarySkeleton";
import {
  deleteRenders,
  downloadRender,
} from "../../../../Redux/actions/projectActions";
import { getProjects } from "../../../../Redux/actions/projectsActions";
import Navbar_render from "../Nav_render/Navbar_render";
import {
  getResolutionFromHeightAndWidth,
  getfpsFromNumAndDen,
} from "../render.constants";
import "./RenderLibrary.css";
import { Scrollx_animate, scrollxLogo } from "../../../../assets/icons";

const RenderLibrary = () => {
  const dispatch = useDispatch();
  const { allProjects } = useSelector((state) => state?.projects);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const downLoadVideo = async (projectId, renderId) => {
    const urlRes = await dispatch(downloadRender(projectId, renderId));
    // console.log("urlRes", urlRes);
    if (urlRes?.success) {
      window.open(urlRes?.data?.downloadURL);
    } else {
      toast.error("URL Not Exist");
    }
  };

  const deleteRender = (projectId, renderId) => {
    const confirm = window.confirm(
      `Are you sure! You want to delete Render (${renderId})?`
    );
    if (confirm) dispatch(deleteRenders(projectId, renderId));
  };

  const rendersSkeleton = () => {
    let skeletons = [];
    for (let i = 0; i < 5; i++) {
      skeletons.push(<RenderLibrarySkeleton />);
    }

    return skeletons;
  };

  const closeModal = () => {
    navigate("/dashboard");
  };

  useEffect(() => {
    setLoading(true);
    dispatch(getProjects()).then(() => {
      setLoading(false);
    });
  }, [allProjects, dispatch]);

  return (
    <>
  
      <div className="renderLibraryDiv">

        <div className="navbarBg">
          <Navbar_render closeModal={closeModal} nameShow={"MY RENDERS"} />
        </div>

        {loading ? (
          <div className="text-white myRenderLoadingContainer flex justify-center items-center">
            <div className="modal-overlayMyRender">
              <img className="absolute opacity-80 myRenderLoading" src={Scrollx_animate} width="140px" height="140px"/>
              <p className="mt-[8rem] text-[0.9rem]">Loading...</p>
            </div>
          </div>
        ) : (
          <div className="renderTable">
 
          <div className="tblHead">
           
            <div className="FontFamily-Avenir-reg font-bold text-[1rem] opacity-[85%] w-[15%]">
              Date
            </div>
            <div className="FontFamily-Avenir-reg font-bold text-[1rem] opacity-[85%] w-[10%]">
              Resolution
            </div>
            <div className="FontFamily-Avenir-reg font-bold text-[1rem] opacity-[85%] w-[10%]">
              Format
            </div>
            <div className="FontFamily-Avenir-reg font-bold text-[1rem] opacity-[85%] w-[10%]">
              FPS
            </div>
            <div className="FontFamily-Avenir-reg font-bold text-[1rem] opacity-[85%] w-[12%]">
              Aspect Ratio
            </div>
            <div className="FontFamily-Avenir-reg font-bold text-[1rem] opacity-[85%] w-[38%]">
              Download video
            </div>
            <div className="FontFamily-Avenir-reg font-bold text-[1rem] opacity-[85%] w-[5%]">
              Action
            </div>

          </div>

          <div className="tblBody">
            {!loading && allProjects.length > 0 && allProjects.map((project, index) => {
            return (
              <div key={project._id} className="w-full mt-[2rem] text-white">
                {project.renders.length > 0 && (
                  <div className="py-4 text-2xl ">
                    <h2 className="projectTitle Syne700 uppercase">{project?.title}</h2>
                  </div>
                )}

                <div className="w-full ">
                  <div className="w-full text-md FontFamily-Avenir-reg 3xl:text-md ">
                    {project?.renders
                      .slice()
                      .reverse()
                      .map((render, idx) =>
                        render && render?.isVideoGenerated ? (
                          <div key={render._id} className="w-full">
                            <div key={idx} className="test11 h-[64px] FontFamily-Avenir-reg w-full flex items-center justify-start">

                              <div className="w-[15%]">
                                {new Date(render?.createdAt).toDateString()} -{" "}
                                {new Date(render?.createdAt)
                                  .toTimeString()
                                  ?.slice(0, 5)}
                              </div>

                              <div className="w-[10%] ">
                                {getResolutionFromHeightAndWidth(
                                  render?.videoHeight,
                                  render?.videoWidth
                                )}
                              </div>

                              <div className="w-[10%]">
                                {String(render?.format).substring(6)}
                              </div>

                              <div className="w-[10%]">
                                {getfpsFromNumAndDen(
                                  render?.fpsNumerator,
                                  render?.fpsDenominator
                                )}
                              </div>

                              <div className="w-[12%]">
                                {render?.aspectRatio}
                              </div>

                              <div className="w-[38%]">
                                {render?.isVideoGenerated ? (
                                  <span
                                    className="cursor-pointer w-[20%]"
                                    style={{ color: "#f1a044" }}
                                    onClick={() =>
                                      downLoadVideo(project._id, render._id)
                                    }
                                  >
                                    {render?.videoFilename
                                      ? render?.videoFilename
                                      : "Download"}
                                  </span>
                                ) : (
                                  <span className="cursor-wait">-</span>
                                )}
                              </div>
                              
                              <div className="w-[5%]">
                                <span
                                  className="cursor-pointer"
                                  onClick={() =>
                                    deleteRender(project._id, render?._id)
                                  }
                                >
                                  <AiOutlineDelete />
                                </span>
                              </div>
                            </div>
                          </div>
                        ) : null
                      )}
                  </div>
                </div>
              </div>
            );
          })}
          </div>
      
          </div>
        )}

      </div>

    </>
  );
};

export default RenderLibrary;